import React from 'react'

export default () =>
  <table className='markdown-reference'>
    <tbody>
      <tr>
        <th>Result</th>
        <th>Markdown</th>
      </tr>
      <tr>
        <td><strong>Bold</strong></td>
        <td>**bold**</td>
      </tr>
      <tr>
        <td><em>Italic</em></td>
        <td>_italic</td>
      </tr>
      <tr>
        <td><code>Code</code></td>
        <td>{'`code`'}</td>
      </tr>
      <tr>
        <td><del>Strike-through</del></td>
        <td>~~Strike-through~~</td>
      </tr>
      <tr>
        <td><a role='button'>Link</a></td>
        <td>[Link](https://)</td>
      </tr>
      <tr>
        <td>Image</td>
        <td>![alt](https://)</td>
      </tr>
      <tr>
        <td>List</td>
        <td>* item</td>
      </tr>
    </tbody>
  </table>



// WEBPACK FOOTER //
// ./app/components/help/MarkdownHelp.js